import { FilterValueRange } from './filter-value-range.model';

export class FilterValue {
  readonly Value?: string;
  readonly Range?: FilterValueRange;

  constructor(value: string);
  constructor(range: FilterValueRange);
  constructor(value: string, range: FilterValueRange);
  constructor(valueOrRange: string | FilterValueRange, range?: FilterValueRange) {
    if (valueOrRange instanceof FilterValueRange) {
      this.Range = valueOrRange;
    } else {
      this.Value = valueOrRange;
      this.Range = range;
    }
  }
}
